'use strict';

(function () {
  'use strict';

  angular.module('msCore').service('MetadataSvc', MetadataService);

  MetadataService.$inject = ['httpSvc', 'NotifyingSvc'];

  /* @ngInject */
  function MetadataService(httpSvc, NotifyingSvc) {
    return {
      fetchProfileComponents: fetchProfileComponents,
      updateProfileComponents: updateProfileComponents,
      getTagsByComponentNames: getTagsByComponentNames
    };

    ////////////////

    /**
     * Fetch all profile components that are stored in the db
     * @returns {*}
     */
    function fetchProfileComponents(youth) {
      var youthQueryParam = youth ? '?youth=true' : '';
      return httpSvc.get('/apiproxy/user/metadata/profile' + youthQueryParam);
    }

    /**
     * persist a tag to the user
     * @param prefs object map containing the values to set in the format {'tag:shortname', 'true/false'}
     * @param youth boolean flag to set this as a 'youth' call.
     * @returns {Promise.<TResult>|*}
     */
    function updateProfileComponents(prefs, youth) {
      var youthQueryParam = youth ? '?youth=true' : '';
      return httpSvc.post('/apiproxy/user/metadata/profile' + youthQueryParam, prefs).then(function (resp) {
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PROFILE_SAVED, {
          complete: true,
          components: resp
        });
        return resp;
      });
    }

    function getTagsByComponentNames(componentNames) {
      // if single-item params, convert to an array
      if (!_.isArray(componentNames)) {
        componentNames = [componentNames];
      }
      var toSearchQP = '';
      if (componentNames.length > 0) {
        toSearchQP = 'name=' + componentNames.join('&name=');
      }
      return httpSvc.get('/apiproxy/user/metadata/tags/components?' + toSearchQP);
    }
  }
})();